import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { CopyDetailsButton, type FallbackArgs } from "@/components/ErrorBoundary";

/**
 * Shown in place of a conversation when its subtree crashes, so the surrounding
 * inbox list / tablero drawer stays usable instead of the whole page going blank.
 * Surfaces the error message so a screenshot is enough to report it, and offers
 * the full stack via the clipboard.
 */
const ChatErrorFallback = ({ reset, error, details }: FallbackArgs) => (
  <div className="flex h-full items-center justify-center p-4">
    <Alert status="error" className="max-w-md">
      <p className="text-sm font-semibold">No pudimos cargar esta conversación</p>
      <p className="mt-1 text-sm">Puedes seguir usando el resto de la página mientras tanto.</p>
      <pre className="mt-2 max-h-24 overflow-auto rounded border border-red-200 bg-white/70 p-2 text-xs whitespace-pre-wrap break-words">
        {error.message}
      </pre>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button size="sm" className="min-h-11" onClick={reset}>
          Reintentar
        </Button>
        <CopyDetailsButton details={details} />
      </div>
    </Alert>
  </div>
);

export default ChatErrorFallback;
